'use client';

import { IconButton } from '@magicschool/spellbook/components/IconButton';
import { cn } from '@magicschool/spellbook/lib/utils';

const FilePreviewCornerAction = ({
  icon,
  ariaLabelledBy,
  onClick,
  alwaysVisible = false,
}: {
  icon: 'x' | 'circle-stop';
  ariaLabelledBy: string;
  onClick: () => void;
  /** When true, no hover/focus-gated reveal — button is always painted (the abort case). */
  alwaysVisible?: boolean;
}) => (
  <IconButton
    name={icon}
    size="sm"
    shape="circle"
    variant="outlined"
    color="neutral"
    aria-labelledby={ariaLabelledBy}
    onClick={onClick}
    className={cn(
      'absolute -top-2.5 -right-2.5 z-10 bg-surface-background-0',
      !alwaysVisible &&
        'opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100 focus-visible:opacity-100',
    )}
  />
);

export { FilePreviewCornerAction };
